import { createContext, useContext } from "react";

import { IUser } from "../types/user";
import { IEmployee } from "../types/employee";

export const UserContext = createContext<IEmployee | undefined>(undefined);

export function useUserContext() {
    const user = useContext(UserContext);

    if (user === undefined) {
        throw new Error("Error: useUserContext is undefined. useUserContext must be used inside a UserContext.Provider");
    } else {
        return user;
    }
}
